export default function getBrowserLang() {
  if (typeof window !== `undefined`) {
    return navigator.languages[0] || navigator.language
  }

  return `en-GB`
}
